import 'vite/modulepreload-polyfill';
import { PUBLIC_PATH } from './config';
import svgxhr from './src/js/helpers/svgxhr';
import './src/js/index';
import.meta.glob(['./src/static/images/**/*', '!./src/static/images/_fpo/**/*']);

svgxhr({ filename: `/${PUBLIC_PATH}images/svgsheet.svg` });
